module.exports = __webpack_public_path__ + "static/media/personal.100ccb38.png";